import apiClient from './apiClient'


const getSchemes = (tenant) => {
  return apiClient.get(`/${tenant}/Scheme`)
}

const getRelations = (tenant, schemeId) => {
  return apiClient.get(`/${tenant}/Scheme/${schemeId}/Relations`)
}

const createScheme = (tenant, scheme) => {
  return apiClient.post(`/${tenant}/Scheme`, scheme)
}

const updateScheme = (tenant, schemeId, scheme) => {
  return apiClient.put(`/${tenant}/Scheme/${schemeId}`, scheme)
}

const deleteScheme = (tenant, schemeId) => {
  return apiClient.delete(`/${tenant}/Scheme/${schemeId}`)
}


export default {
  getSchemes,
  getRelations,
  createScheme,
  updateScheme,
  deleteScheme
}
